<template>
  <div class="d-flex flex-column align-items-center justify-content-center" :style="`margin-top: ${marginHeader};`">
    <i class="fas fa-folder-open " style="color: #e9ecef;" :class="sizeClass.icon"></i>
    <p class="text-light m-0" :class="sizeClass.text">{{text}}</p>
  </div>
</template>

<script>
  export default {
    data(){
      return {
        marginHeader: '0'
      }
    },
    props: {
      text: {
        type: String,
        default: 'No hay datos'
      },
      size: {
        type: String,
        default: 'md'
      }
    },
    created(){
      if(this.params && this.params.api){
        this.marginHeader = '40px';
      }
    },
    computed:{
      sizeClass(){
        if(this.size === 'sm'){
          return {
            icon: 'fa-2x mb-2',
            text: 'text-xs'
          }
        } else { // default to 'md'
          return {
            icon: 'fa-3x mb-3',
            text: 'text-sm'
          }
        }
      } 
    }
  }
</script>

<style lang="scss" scoped>

</style>